// import { SHARED_SECTIONS } from "./formBaseConfig";
// export const BUSINESS_FORMS = {
 

//   26: {
//     sections: [
//       SHARED_SECTIONS.Uploaded_Documents,
//       SHARED_SECTIONS.PERSONAL,
//       SHARED_SECTIONS.EMPLOYMENT,
//       SHARED_SECTIONS.PASSPORT,
//       SHARED_SECTIONS.ADDRESS,
//       SHARED_SECTIONS.TRAVEL,
//       SHARED_SECTIONS.DECLARATION,
//     ],
//   },

//   27: {
//     sections: [
//       SHARED_SECTIONS.Uploaded_Documents,
//       SHARED_SECTIONS.PERSONAL,
//       SHARED_SECTIONS.EMPLOYMENT,
//       SHARED_SECTIONS.PASSPORT,
//       SHARED_SECTIONS.ADDRESS,
//       SHARED_SECTIONS.TRAVEL,
//       SHARED_SECTIONS.DECLARATION,
//     ],
//   },

//   29: {
//     sections: [
//       SHARED_SECTIONS.Uploaded_Documents,
//       SHARED_SECTIONS.PERSONAL,
//       SHARED_SECTIONS.EMPLOYMENT,
//       SHARED_SECTIONS.PASSPORT,
//       SHARED_SECTIONS.ADDRESS,
//       SHARED_SECTIONS.TRAVEL,
//       SHARED_SECTIONS.DECLARATION,
//     ],
//   },

// };


import { SHARED_SECTIONS } from "./formBaseConfig";

export const BUSINESS_FORMS = {
 
  26: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      {
        ...SHARED_SECTIONS.PERSONAL,
      },
      {
        ...SHARED_SECTIONS.EMPLOYMENT,
        subTabs: [
          {
            ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0],
            fields: [
              ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0].fields,
              // Company Details
              {
                name: "applicant_company_name",
                label: "Company Name",
                type: "text",
                required: false,
                extract_key: "Company Name",
                section: "Company Details",
              },
              {
                name: "applicant_company_website",
                label: "Company Website",
                type: "text",
                required: false,
                extract_key: "Company Website",
                section: "Company Details",
              },
              {
                name: "applicant_company_address_phone",
                label: "Company Address & Phone",
                type: "text",
                required: false,
                extract_key: "Company Address Phone",
                section: "Company Details",
                fullWidth: true,
              },
              {
                name: "nature_of_business_product",
                label: "Nature of Business/Product",
                type: "text",
                required: false,
                extract_key: "Nature of Business / Product",
                section: "Company Details",
                fullWidth: true,
              },
            ],
          },
        ],
      },
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  27: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      {
        ...SHARED_SECTIONS.EMPLOYMENT,
        subTabs: [
          {
            ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0],
            fields: [
              ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0].fields,
              // Company Details
              {
                name: "applicant_company_name",
                label: "Company Name",
                type: "text",
                required: false,
                extract_key: "Applicant Company Name",
                section: "Company Details",
              },
              {
                name: "applicant_company_website",
                label: "Company Website",
                type: "text",
                required: false,
                extract_key: "Applicant Company Website",
                section: "Company Details",
              },
              {
                name: "applicant_company_address_phone",
                label: "Company Address & Phone",
                type: "text",
                required: false,
                extract_key: "Applicant Company Address Phone",
                section: "Company Details",
                fullWidth: true,
              },
              {
                name: "nature_of_business_product",
                label: "Nature of Business/Product",
                type: "text",
                required: false,
                extract_key: "Nature of Business Product",
                section: "Company Details",
                fullWidth: true,
              },
            ],
          },
        ],
      },
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  29: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      {
        ...SHARED_SECTIONS.EMPLOYMENT,
        subTabs: [
          {
            ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0],
            fields: [
              ...SHARED_SECTIONS.EMPLOYMENT.subTabs[0].fields,
              // Company Details
              {
                name: "applicant_company_name",
                label: "Company Name",
                type: "text",
                required: false,
                extract_key: "Applicant Company Name",
                section: "Company Details",
              },
              {
                name: "applicant_company_website",
                label: "Company Website",
                type: "text",
                required: false,
                extract_key: "Applicant Company Website",
                section: "Company Details",
              },
              {
                name: "applicant_company_address_phone",
                label: "Company Address & Phone",
                type: "text",
                required: false,
                extract_key: "Applicant Company Address Phone",
                section: "Company Details",
                fullWidth: true,
              },
              {
                name: "nature_of_business_product",
                label: "Nature of Business/Product",
                type: "text",
                required: false,
                extract_key: "Nature of Business Product",
                section: "Company Details",
                fullWidth: true,
              },
            ],
          },
        ],
      },
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

};